<template lang="pug">
table.table-hover.reports-table.attendance-report-table.table
  tbody.thead
    tr
      th.sticky-cell
        template(v-if="!tableIsTeam")
          | Date
        template(v-else)
          template(v-if="reportQuery.group_by === 'member'")
            | Date
          template(v-else-if="reportQuery.group_by === 'date'")
            | Member
      th Status
      th Work order
      th Job
      th Scheduled time
      th Time started
      th Scheduled (hrs)
      th Worked (hrs)
      th Late (hrs)

  // eslint-disable vue/require-v-for-key
  template(v-for="section in tableData.sections")
    tbody.grouping-header
      tr
        th
          template(v-if="walker.main_type === 'date'")
            | {{ $filters.formatDate(section.main) }}
          template(v-else-if="walker.main_type === 'member'")
            ReportTableAvatar(
              :user-id="section.main_id"
              :url="section.rows[0].record.avatar_url"
            )
            | {{ section.main }}
          template(v-else)
            | {{ section.main }}
        td(
          v-for="col in 8"
          :key="col"
        )

    // eslint-disable vue/valid-v-for

    ReportVirtualTableBody(
      v-slot="{ row }"
      :rows="section.rows"
    )
      tr
        td.sticky-cell
          template(v-if="walker.main_type === 'date'")
            ReportTableAvatar(
              :user-id="row.record.sub_id"
              :url="row.record.avatar_url"
            )
            | {{ row.record.sub }}
          template(v-else)
            | {{ $filters.formatDate(row.record.sub) }}
        td
          span.label.job-status(:class="'label-' + row.record.status_sym") {{ row.record.status_name }}
        td
          span(
            v-tooltip
            :title="`${row.record.wo_number} - ${row.record.client_name}`"
          )
            | {{ row.record.wo_number }} - {{ row.record.client_name }}
        td
          | {{ row.record.job_id }}
        td(v-if="row.record.start_time && row.record.stop_time")
          span(
            v-tooltip
            :title="$filters.formatDatetimeRangeWithZone(row.record.start_time, row.record.stop_time, false, true)"
          )
            | {{ $filters.formatDatetimeRangeWithZone(row.record.start_time, row.record.stop_time, false, true) }}
        td.shift-cell(v-else)
          | N/A - N/A
        td(v-if="row.record.actual_start_time")
          span(
            v-tooltip
            :title="$filters.formatDateTime(row.record.actual_start_time)"
          )
            | {{ $filters.formatTimeWithZone(row.record.actual_start_time, false) }}
        td(v-else)
          | &mdash;
        td
          | {{ $filters.formatDuration(row.record.duration, false, null, false, true) }}
        td
          | {{ $filters.formatDuration(row.record.actual_duration, false, null, false, true) }}
        td
          | {{ $filters.formatDuration(row.record.late, false, null, false, true) }}
    // eslint-enable vue/require-v-for-key
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'JobAttendanceReportTable',
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['walker', 'tableIsTeam', 'reportQuery']),
    ...mapState(['organization']),
  },
};
</script>
